import ExcelJS from 'exceljs';

export default file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = async function(e) {
    try {
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(e.target.result);
      return resolve(workbook);
    } catch (error) {
      return reject(error);
    }
  };
  reader.readAsArrayBuffer(file);
});
